import Vue from 'vue'
import $ from 'jquery';
import moment from "moment";
import * as functionsCandys from "./functionsCandys.js";

/*Section Ticket/Candy*/
import PopupAlert from "./components/PopupAlert.vue";
import Total from "./components/Total.vue";

/*Section Candy*/
import CandyCategory from "./components/CandyCategory.vue";
import CandyTicket from './components/CandyTicket.vue'
import CandyCart from "./components/CandyCart.vue";

//Mode Dev
Vue.config.devtools = false;

require("sumoselect");

var vm = new Vue({
  el: '#app',
  components: {
    /*Section Ticket/Candy*/
    "v-popup": PopupAlert,
    "v-total": Total,

    /*Section Candy*/
    "v-candycategory": CandyCategory,
    "v-candyticket": CandyTicket,
    "v-candycart": CandyCart,
  },
  data: {
    d_total_member_points: 0,
    //Si hay un member logueado.
    d_member: null,

    //Lista de BalanceTypes
    d_balance_types: [],

    /*Section Candy*/
    //Subtotal de la orden
    d_subtotal_value: 0,
    //Datos de las categorias con los candys.
    d_json_candys: null,
    //Carrito de candys.
    d_cart_candys: null,
    //Cantidad totales de candys que se pueden agregar a la orden.
    d_qty_candys_operation: 7,
    //total para los tickets.
    d_total_candy: '$0',
    //Subtotal para los candys
    d_subtotal_candy: '$0',
    //Service candys para los candys
    d_c_service_candy: '$0',
    //Total value de candys para sumar en el total de candys.
    d_total_candys_value: 0,
    //Total de service charge para sumar en el total de candys.
    d_total_candys_service: 0,
    //Service charge por defecto a sumar en el carrito de candys.
    d_default_candys_service: 0,

    // Definicion de urls.
    d_get_url_candys: window.UrlCandys,
    d_get_url_web: window.UrlWeb,
    d_get_url_ticketing: window.UrlTicketing,
    d_get_url_candy_images: window.UrlStaticContentCandyImages,
    // Definicion de fecha de versionado de cache
    d_get_date_version_cache: window.DateVersionCache,
    d_group_rules_candys: [],
    d_show_promotion_desc: false,

    ///////////////////
    // DATALAYER GA4 //
    ///////////////////

    d_datalayer: null,
    d_base_item: null,
    d_current_item: null,
    d_dl_total: 0
  },
  watch: {
    /*Section Candy*/
    d_cart_candys: function () {
      this.m_calculate_total_candy();
      //habilito/deshabilito el boton de siguiente si hay o no elementos en el carrito.
      $('#btnNext').prop('disabled', !(this.d_cart_candys && this.d_cart_candys.length > 0));

      var qty = functionsCandys.GetQty(this.d_json_candys, this.d_cart_candys);
      if (qty) {
        $('.cart-counter.cart-counter_candy').addClass('active').find('.cart-counter-value').html(qty);
      }
      else {
        $('.cart-counter.cart-counter_candy').removeClass('active');
      }
    }
  },
  computed: {
    /*Section Candy*/
    //Devuelve las categorias con los candy.      
    c_get_categories_candy: function () {
      return this.d_json_candys;
    },
    //Devuleve el carrito con los candys.   
    c_get_cart_candys: function () {
      return this.d_cart_candys;
    }
  },
  methods: {

    ////////////////////////
    /*Section Ticket/Candy*/
    ////////////////////////

    //Abre el popup con el mensaje dependiendo de los argumentos.  
    m_show_popup: function (args) {
      this.$refs.popupalert.m_open(args);
    },
    //Retorna el nombre del balance type.
    m_get_balance_name: function (enuPointsType, intBalanceTypeId, forCart = null, plural = true) {
      var balancetype = this.d_balance_types.find(item => item.enuPointsType == enuPointsType && item.intBalanceTypeId == intBalanceTypeId);
      if (balancetype != null)
        return (forCart ? balancetype.strCartName : this.m_plural(balancetype.strName, plural));
      else
        return ""
    },
    m_plural: function (Name, plural = true) {
      if (plural) {
        Name = Name.replace(/\bENTRADA\b/, "ENTRADAS");
        Name = Name.replace(/\bEntrada\b/, "Entradas");
        Name = Name.replace(/\bPUNTO\b/, "PUNTOS");
        Name = Name.replace(/\bPunto\b/, "Puntos");
      } else {
        Name = Name.replace(/\bENTRADAS\b/, "ENTRADA");
        Name = Name.replace(/\bEntradas\b/, "Entrada");
        Name = Name.replace(/\bPUNTOS\b/, "PUNTO");
        Name = Name.replace(/\bPuntos\b/, "Punto");
      }
      return Name;
    },

    /////////////////
    /*Section Candy*/
    /////////////////

    //Retorna la cantidad de puntos de candys para un balance type.
    m_get_candys_total_balance_points: function (JsonCandys, CartCandys, enuPointsType, intBalanceTypeId) {
      if ((CartCandys == null) || (enuPointsType == 0 && intBalanceTypeId == 0))
        return 0;
      var totalPoints = 0;
      CartCandys.forEach(orderItem => {
        var candy = functionsCandys.GetCandy(JsonCandys, orderItem.strMCode, orderItem.strBarcode);
        var option = functionsCandys.GetOption(candy, orderItem.intRecogId, orderItem.intPromoId);
        // Recorro los Balance del Option
        option.lstBalances.forEach(balance => {
          if (balance.enuPointsType == enuPointsType && balance.intBalanceId == intBalanceTypeId)
            totalPoints += (orderItem.intQty * balance.intPoints);
        });
      });
      var balancetype = this.d_balance_types.find(item => item.enuPointsType == enuPointsType && item.intBalanceTypeId == intBalanceTypeId);
      return totalPoints + balancetype.intOrderPoints;
    },

    //Retorna un string con el total de precio + puntos del carrito.
    m_get_candys_string_total_value_and_points: function (JsonCandys, CartCandys, total_tickets_value, total_tickets_service) {
      if (CartCandys == null)
        return '$0';
      var totalPrice = 0;
      var qty = 0;
      CartCandys.forEach(orderItem => {
        var candy = functionsCandys.GetCandy(JsonCandys, orderItem.strMCode, orderItem.strBarcode);
        var option = functionsCandys.GetOption(candy, orderItem.intRecogId, orderItem.intPromoId);

        totalPrice = totalPrice + (orderItem.intQty * option.intValue);
        qty = qty + 1;
      });

      // DataLayerGA4 - Persisto el total en d_dl_total
      this.d_dl_total = totalPrice / 100;

      var price = (((totalPrice + total_tickets_value + total_tickets_service) / 100).toLocaleString('es-AR'));
      var result = "$" + price;

      // Recorro balance types
      this.d_balance_types.forEach(balanceItem => {
        var totalPoints = this.m_get_candys_total_balance_points(JsonCandys, CartCandys, balanceItem.enuPointsType, balanceItem.intBalanceTypeId);
        if (totalPoints > 0)
          result = result + " + " + totalPoints.toLocaleString('es-AR') + " " + balanceItem.strCartName;
      });
      return result;
    },
    //Obtine el ticket de candys de los disponibles.
    m_get_ticket_candy: function (strMCode, strBarcode) {
      return functionsCandys.GetCandy(this.d_json_candys, strMCode, strBarcode);
    },
    //Obtiene el option de un candys por el intRecogId y intPromoId.
    m_get_option_candy: function (TicketCandy, intRecogId, intPromoId) {
      return functionsCandys.GetOption(TicketCandy, intRecogId, intPromoId);
    },
    //Agrega una unidad del candy al carrito de candys.
    m_add_candy: function (strMCode, strBarcode, intRecogId, intPromoId, boms) {
      var candy = functionsCandys.GetCandy(this.d_json_candys, strMCode, strBarcode);
      var option = functionsCandys.GetOption(candy, intRecogId, intPromoId);

      //Verifico si la orden es onlybook no dejo seleccionar candys onlybuy 
      if (this.d_only_book && (candy.bitOnlyBuy || intRecogId != 0)) {
        this.m_show_popup({ idMsg: 3002 });
        return false;
      }

      //Si tiene regla de grupo verifico que no haya sido agregado un candy y sino
      //lo agrego a la lista de control. //flag = true: agrega regla, flag = false: quita regla
      if (candy.strGroupRule) {
        var ruleItem = this.d_group_rules_candys.find(item => (item.strGroupRule == candy.strGroupRule && item.strMCode != candy.strMCode));
        if (ruleItem) {
          this.m_show_popup({ idMsg: 3003, strTitle: ruleItem.strTitle });
          return false;
        }
      }

      //Obtengo la cantidad de candys seleccionados. 
      var qty_candys_selected = functionsCandys.GetQty(this.d_json_candys, this.d_cart_candys);

      if (qty_candys_selected + option.intButtonQty > this.d_qty_candys_operation) {
        //lanza el popin en caso de que se supere la cantidad maxima de tickets seleccionados         
        this.m_show_popup({ idMsg: 3000, candysQtyOperation: this.d_qty_candys_operation });
      } else {
        var optionQty = functionsCandys.GetQty(this.d_json_candys, this.d_cart_candys, strMCode, strBarcode, intRecogId, intPromoId);
        if (optionQty + option.intButtonQty > option.intMaxQty) {
          this.m_show_popup({ idMsg: 3001, strTitle: candy.strTitle, candysMaxQty: option.intMaxQty });
        } else {
          var enoughPoints = true;
          // Recorro los Balance del Option
          option.lstBalances.forEach(balance => {
            var balanceType = this.d_balance_types.find(item => item.enuPointsType == balance.enuPointsType && item.intBalanceTypeId == balance.intBalanceId);
            if (balanceType != null) {
              // Calculo puntos usados
              var balacePointsUsed = this.m_get_candys_total_balance_points(this.d_json_candys, this.d_cart_candys, balance.enuPointsType, balance.intBalanceId);
              // Defino puntos disponibles
              var balancePointsAvailable = balanceType.intMemberPoints - balacePointsUsed;
            } else {
              var balancePointsAvailable = 0;
            }
            // Si no dispongo de los suficientes puntos
            if (balancePointsAvailable - balance.intPoints < 0) {
              enoughPoints = false;
              this.m_show_popup({ idMsg: 1, memberPoints: balancePointsAvailable, requiredPoints: balance.intPoints - balancePointsAvailable, balanceNameAlt: balanceType.strNameAlt });
            }
          });
          if (enoughPoints) {
            this.d_cart_candys = functionsCandys.UpdateOrder(this.d_cart_candys, strMCode, strBarcode, intRecogId, option.intButtonQty, boms, intPromoId);
            this.m_update_group_rule_candy(candy, true);
            this.m_calculate_total_candy();
          }
        }
      }
      var qty = functionsCandys.GetQty(this.d_json_candys, this.d_cart_candys);
      if (qty) {
        $('.cart-counter.cart-counter_candy').addClass('active').find('.cart-counter-value').html(qty);
      }
      else {
        $('.cart-counter.cart-counter_candy').removeClass('active');
      }
    },
    //Quita una unidad del candy del carrito de candys.
    m_del_candy: function (strMCode, strBarcode, intRecogId, intPromoId, boms) {
      var candy = functionsCandys.GetCandy(this.d_json_candys, strMCode, strBarcode);
      var option = functionsCandys.GetOption(candy, intRecogId, intPromoId);
      this.d_cart_candys = functionsCandys.UpdateOrder(this.d_cart_candys, strMCode, strBarcode, intRecogId, -option.intButtonQty, boms, intPromoId);
      this.m_calculate_total_candy();
      if (candy.strGroupRule) {
        var candyQty = functionsCandys.GetQty(this.d_json_candys, this.d_cart_candys, strMCode, strBarcode, intRecogId, intPromoId);
        candyQty == 0 && this.m_update_group_rule_candy(candy, false);
      }
      var qty = functionsCandys.GetQty(this.d_json_candys, this.d_cart_candys);

      if (qty) {
        $('.cart-counter.cart-counter_candy').addClass('active').find('.cart-counter-value').html(qty);
      }
      else {
        $('.cart-counter.cart-counter_candy').removeClass('active');
      }
    },
    //Borra todos los tickets dependiendo del strMCode.
    m_del_all_ticket_candy: function (strMCode, strBarcode, intRecogId, intQty, boms, intPromoId) {
      //Obtengo el ticket candy    
      var candy = functionsCandys.GetCandy(this.d_json_candys, strMCode, strBarcode);
      //Obtengo el option para usar el intButtonQty
      var option = functionsCandys.GetOption(candy, intRecogId, intPromoId);
      //Itero para borrar todos los items del carrito.
      for (let index = 0; index < intQty / option.intButtonQty; index++) {
        this.m_del_candy(strMCode, strBarcode, intRecogId, intPromoId, boms);
      }
    },
    //Retorna la cantidad de candys totales, por strMCode o por strMCode y intRecogId.    
    m_get_ticket_candy_qty: function (strMCode, strBarcode, intRecogId, intPromoId) {
      return functionsCandys.GetQty(this.d_json_candys, this.d_cart_candys, strMCode, strBarcode, intRecogId, intPromoId);
    },
    //Calcula el total de los candys en el carrito entre precio y puntos.
    m_calculate_total_candy: function () {
      this.d_total_candy = this.m_get_candys_string_total_value_and_points(this.d_json_candys, this.d_cart_candys, this.d_subtotal_value, 0);
    },
    //Trae el nombre del primer elemento del carrito de candys solo compra .
    m_first_candy_only_buy: function () {
      return functionsCandys.FirsItemOnlyBuy(this.d_json_candys, this.d_cart_candys);
    },
    m_is_cinefan: function (id) {
      return window.cinefanCategoryId == id;
    },
    //Agrega o elimina en d_group_rules_candys los grupos de los candys seleccionados. 
    //flag = true: agrega regla, flag = false: quita regla
    m_update_group_rule_candy: function (candy, flag) {
      //Genero el nuevo item.
      var newGroupItem = { strGroupRule: candy.strGroupRule, strMCode: candy.strMCode, strTitle: candy.strTitle };
      if (flag) {
        //Busco si ya se encuentra el grupo cargado sino lo agrego.
        var ruleItem = this.d_group_rules_candys.find(item => item.strGroupRule == newGroupItem.strGroupRule);
        !ruleItem && this.d_group_rules_candys.push(newGroupItem);
      } else {
        //Si se encuentra lo elimino.
        var index = this.d_group_rules_candys.findIndex(item => item.strGroupRule == newGroupItem.strGroupRule);
        index > -1 && this.d_group_rules_candys.splice(index, 1);
      }
    },
    ///////////////////
    // DATALAYER GA4 //
    ///////////////////
    // Retorno intCategoryId y strTitle de la categoria de un Ticket
    findCategoryByCandyCode(strMCode) {
      for (const category of this.d_json_candys) {
        for (const candy of category.Candys) {
          if (candy.strMCode === strMCode) {
            return {
              intCategoryId: category.intCategoryId,
              strTitle: category.strTitle
            };
          }
        }
      }
      return null; // Retorna null si no se encuentra la categoría
    },
    m_datalayer_set_candys: function (CartCandys) {
      // Actualizo value
      this.d_datalayer.ecommerce.value = this.d_dl_total;

      // Vacía la lista de items
      this.d_datalayer.ecommerce.items.length = 0;

      // Difino Index
      var Index = 1;

      // Recorro CartCandys
      CartCandys.forEach(function (Item) {
        var candy = this.m_get_ticket_candy(Item.strMCode, Item.strBarcode);
        var option = this.m_get_option_candy(candy, Item.intRecogId, Item.intPromoId);

        // Map de d_base_item
        this.d_current_item = Object.assign({}, this.d_base_item);
        this.d_current_item.item_name = candy.strTitle;
        this.d_current_item.item_id = candy.strMCode;
        this.d_current_item.price = option.intValue / 100;

        // Puntos Cine Fan
        const puntosCineFanBalance = option.lstBalances.find(balance => balance.enuPointsType === 1 && balance.intBalanceId === 1);
        if (puntosCineFanBalance) {
          this.d_current_item.puntos_cinefan = Item.intQty * puntosCineFanBalance.intPoints;
        }

        // Puntos YPF
        const puntosYPFBalance = option.lstBalances.find(balance => balance.enuPointsType === 2 && balance.intBalanceId === 0);
        if (puntosYPFBalance) {
          this.d_current_item.puntos_ypf = Item.intQty * puntosYPFBalance.intPoints;
        }

        // Entradas Cine Fan
        const entradasCineFanBalance = option.lstBalances.find(balance => balance.enuPointsType === 1 && (balance.intBalanceId === 4 || balance.intBalanceId === 9));
        if (entradasCineFanBalance) {
          this.d_current_item.entradas = Item.intQty * entradasCineFanBalance.intPoints;
        }

        // Busco la categoria
        const category = this.findCategoryByCandyCode(Item.strMCode);
        this.d_current_item.item_list_name = category.strTitle;
        this.d_current_item.item_list_id = category.intCategoryId;

        this.d_current_item.index = Index;
        this.d_current_item.quantity = Item.intQty;

        // Agrego d_current_item
        this.d_datalayer.ecommerce.items.push(this.d_current_item);

        // Sumo 1 al Index
        Index = Index + 1;
      }, this); // Pasa el contexto actual al foreach
    },
    m_datalayer_set_payment: function () {
      // Actualizo el event
      this.d_datalayer.event = "add_payment_info";

      //Actualizo order_state
      this.d_datalayer.ecommerce.order_state = undefined;

      //Comprobamos si existe el elemento con id = ddlcardtype
      if ($("#ddlcardtype").length > 0) {
        //Si entra en el if significa que el elemento no está vacío
        //Entonces existe y podemos usarlo con seguridad
        // Actualizo payment_type con el valor del selector
        this.d_datalayer.ecommerce.payment_type = $("#ddlcardtype").val();
      }
      else {
          // Si el elemento no existe, actualizamos payment_type con tipo Canje
          this.d_datalayer.ecommerce.payment_type = "Canje";
      }
    }
  }
})

/*Section Ticket/Candy*/
window.$ = $;
window.jQuery = $;
//Defino la url del home
//window.SetWebUrl = function(strUrl){
//window.WEB_URL = strUrl;
//window.WEB_URL = 'http://cinemarkhoyts.nextdevelop.com.ar/';
//}

//test
//window.vm = vm;

$('#btnNext, #btnBack').click(function (e) {
  var datos = null;
  if (vm.d_json_candys) {
    datos = { candys: vm.d_cart_candys };
  }
  datos && $("#DataCurrentClient").val(JSON.stringify(datos));
});

/*Section Candy*/
window.SetDataCandy = function (data) {
  vm.d_json_candys = data;
}

window.SetCurrentDataCandy = function (data) {
  vm.d_subtotal_value = data.subtotal_value;
  vm.d_cart_candys = data.candys;
  vm.d_default_candys_service = data.default_candys_service;
  vm.d_total_candys_service = data.total_candys_service;
  vm.d_balance_types = data.balance_types;
  data.candys.forEach(element => {
    var candy = functionsCandys.GetCandy(vm.d_json_candys, element.strMCode, element.strBarcode);
    //Si tiene regla de grupo lo agrego a la lista de control.
    if (candy.strGroupRule) {
      vm.m_update_group_rule_candy(candy, true);
    }
  });
}

window.IsCartCandy = function () {
  return vm.d_cart_candys && vm.d_cart_candys.length > 0;
}

//Setea el usuario que se logeo
window.SetMember = function (d) {
  vm.d_member = d;
}

window.SetShowPromotionDesc = function (d) {
  vm.d_show_promotion_desc = d;
}

///////////////////
// DATALAYER GA4 //
///////////////////

window.SetDataLayer = function (d) {
  vm.d_datalayer = d;
}

window.SetBaseItem = function (d) {
  vm.d_base_item = d;
}

window.PushDataLayer = function () {
  if (window.DataLayerGA4Enabled == "Y") {
    dataLayer.push({ ecommerce: null });
    dataLayer.push(vm.d_datalayer);
  }
}

window.DataLayerClick = function () {
  // Genero DataLayerGA4 Candy
  if (window.location.href.includes("nsCandys") || window.location.href.includes("nsCanjes")) {
    vm.m_datalayer_set_candys(vm.d_cart_candys);
    window.PushDataLayer();
  }

  // Genero DataLayerGA4 Payment
  if (window.location.href.includes("nsPayment")) {
    vm.m_datalayer_set_payment();
    // Si el formulario esta completo
    if (Form1.checkValidity()) {
      window.PushDataLayer();
    }
  }

  // Guardo DataLayerGA4
  $("#HFDataLayerGA4").val(JSON.stringify(vm.d_datalayer));
}


// WEBPACK FOOTER //
// ./src/main.js